import { useState, useEffect } from "react";
import { Stack, Pagination } from "@mui/material";
import Div from "../../../components/Div";
import PageTitle from "../../../components/PageTitle";
import { getOperationsStatusListHttp } from "../../../http/renewalHttp/RenewalHttp";
import { Badge } from 'react-bootstrap';
import { API_URL } from "../../../config";
import { getToken } from "../../../util/validation";

export default function GetOperationsStatus() {
    const [statusList, setStatusList] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 15;
    const token = JSON.parse(getToken);
    const [searchTerm, setSearchTerm] = useState("");
    const [agreementModal, setAgreementModal] = useState({ open: false, item: null });

    const skuOptions = [
        "Google Workspace Business Starter",
        "Google Workspace Business Standard",
        "Google Workspace Business Plus",
        "Google Workspace Enterprise Starter",
        "Google Workspace Enterprise Standard",
        "Google Workspace Enterprise Plus",
        "Google Workspace for Education Fundamentals",
        "Google Workspace for Education Standard",
        "Google Workspace for Education Plus"
    ];

    const [formData, setFormData] = useState({
        client_name: '',
        price: '',
        term: '1 Year',
        payment_term: 'Annually',
        company_name: '',
        domain_name: '',
        company_address: '',
        designation: '',
        client_email: '',
        support_charges: '',
        start_date: '',
        end_date: '',
        // Initialize plans array
        plans: [{ sku_name: skuOptions[0], license_count: '1' }],
        plans: [{ sku_name: skuOptions[0], license_count: '1', price: '' }]
    });

    useEffect(() => {
    const fetchExistingData = async () => {
        // Only proceed if the modal is actually open
        if (!agreementModal.open || !agreementModal.item) return;

        // SCENARIO 1: EDIT MODE (Agreement already exists)
        if (agreementModal.item.agreement_url) {
            try {
                const response = await fetch(API_URL + 'adminpanel/get_existing_agreement/', {
                    method: 'POST',
                    headers: { 
                        'Content-Type': 'application/json', 
                        'Authorization': token.login_token 
                    },
                    body: JSON.stringify({ renewal_id: agreementModal.item.renewal_id }),
                });
                const result = await response.json();
                
                if (result.data) {
                    const saved = result.data;
                    
                    // Logic to turn the comma-separated strings back into an array for the form
                    const skus = saved.selected_sku ? saved.selected_sku.split(', ') : [];
                    const counts = saved.license_count ? saved.license_count.split(', ') : [];
                    const prices = saved.price ? saved.price.split(', ') : [];

                    const reconstructedPlans = skus.map((sku, i) => ({
                        sku_name: sku,
                        license_count: counts[i] || '1',
                        price: prices[i] || ''
                    }));

                    setFormData({
                        client_name: saved.client_name || '',
                        company_name: saved.company_name || '',
                        company_address: saved.company_address || '',
                        domain_name: saved.domain_name || '',
                        designation: saved.designation || '',
                        client_email: saved.client_email || '',
                        term: saved.term || '1 Year',
                        payment_term: saved.payment_term || 'Annually',
                        support_charges: saved.support_charges || '0.00',
                        start_date: saved.start_date || '',
                        end_date: saved.end_date || '',
                        plans: reconstructedPlans.length > 0 ? reconstructedPlans : [{ sku_name: skuOptions[0], license_count: '1', price: '' }]
                    });
                }
            } catch (error) { 
                console.error("Error fetching existing agreement:", error); 
            }
        } 
        
        else {
            setFormData({
                client_name: '',
                company_name: agreementModal.item.company_name || '', 
                domain_name: agreementModal.item.domain_name || '', 
                company_address: '',
                designation: '',
                client_email: '',
                term: '1 Year',
                payment_term: 'Annually',
                support_charges: '0',
                start_date: '',
                end_date: '',
                plans: [{ 
                    sku_name: skuOptions[0], 
                    license_count: agreementModal.item.license_count ? String(agreementModal.item.license_count) : '1', 
                    price: '' 
                }]
            });
        }
    };

    fetchExistingData();
}, [agreementModal.open, agreementModal.item]);

  
    const handleAddPlan = () => {
        setFormData({
            ...formData,
            plans: [...formData.plans, { sku_name: skuOptions[0], license_count: '1', price: '' }]
        });
    };

    const handleRemovePlan = (index) => {
        const updatedPlans = formData.plans.filter((_, i) => i !== index);
        setFormData({ ...formData, plans: updatedPlans });
    };

    const handlePlanChange = (index, field, value) => {
        const updatedPlans = [...formData.plans];
        updatedPlans[index][field] = value;
        setFormData({ ...formData, plans: updatedPlans });
    };
    // ------------------------

    const handleGeneratePDF = async () => {
        // Ensure numeric fields are actually numbers to avoid "plus/minus" confusion
        const total_support = parseFloat(formData.support_charges || 0);

        const payload = {
            renewal_id: agreementModal.item.renewal_id,
            domain_name: formData.domain_name,
            company_name: formData.company_name,
            client_name: formData.client_name,
            // Ensure price is rounded
            price: parseFloat(formData.price || 0).toFixed(2),
            term: formData.term,
            payment_term: formData.payment_term,
            company_address: formData.company_address || '________',
            designation: formData.designation || '________',
            client_email: formData.client_email || '________',
            support_charges: total_support.toFixed(2),
            start_date: formData.start_date,
            end_date: formData.end_date,
            // Map plans and ensure license_count is an Integer
            plans: formData.plans.map(p => ({
                ...p,
                license_count: parseInt(p.license_count || 0),
                price: parseFloat(p.price || 0).toFixed(2)
            }))
        };

        try {
            const response = await fetch(API_URL + 'adminpanel/generate_agreement/', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token.login_token
                },
                body: JSON.stringify(payload),
            });

            if (response.ok) {
                alert("Agreement generated and stored successfully!");
                setAgreementModal({ open: false, item: null });
                const refreshRes = await getOperationsStatusListHttp();
                if (refreshRes && refreshRes.status_list) {
                    setStatusList(refreshRes.status_list);
                }
            } else {
                const result = await response.json();
                alert("Error: " + result.error);
            }
        } catch (error) {
            alert("Network Error: Could not connect to server.");
        }
    };

    const handleViewAgreement = async (gcsPath) => {
        if (!gcsPath) { alert("Agreement not found."); return; }
        try {
            const response = await fetch(API_URL + 'adminpanel/get_view_agreement_url/', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Authorization': token.login_token },
                body: JSON.stringify({ gcs_path: gcsPath }),
            });
            const result = await response.json();
            if (response.ok && result.url) { window.open(result.url, '_blank'); }
        } catch (error) { alert("Error retrieving secure link."); }
    };

    useEffect(() => {
        const fetchStatusData = async () => {
            const response = await getOperationsStatusListHttp();
            if (response && response.status_list) { setStatusList(response.status_list); }
        };
        fetchStatusData();
    }, []);

    const filteredList = statusList.filter(item =>
        item.domain_name.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = filteredList.slice(indexOfFirstItem, indexOfLastItem);
    const totalPages = Math.ceil(filteredList.length / itemsPerPage);

    const handlePageChange = (event, value) => { setCurrentPage(value); };

    return (
        <>
            <PageTitle title="Domain Status Dashboard" />

            <Div className="col-md-12 mb-4">
                <div className="input-group" style={{ maxWidth: '250px' }}>
                    <input
                        type="text"
                        className="form-control"
                        placeholder="Search Domain Name..."
                        value={searchTerm}
                        style={{
                            border: '1px solid black',
                            borderRadius: '4px'
                        }}
                        onChange={(e) => setSearchTerm(e.target.value)}
                    />
                </div>
            </Div>

            {agreementModal.open && (
                <div style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1000, display: 'flex', justifyContent: 'center', alignItems: 'flex-start', padding: '20px', overflowY: 'auto' }}>
                    <div style={{ backgroundColor: 'white', padding: '25px', borderRadius: '8px', width: '100%', maxWidth: '600px', boxShadow: '0 4px 15px rgba(0,0,0,0.2)', margin: 'auto' }}>
                        <h5 className="mb-4">📜 Create Service Agreement</h5>

                        <div style={{ maxHeight: '65vh', overflowY: 'auto', paddingRight: '10px', marginBottom: '15px' }}>

                            <div className="mb-3">
                                <label className="fw-bold">Execution Date:</label>
                                <input type="text" className="form-control" value={new Date().toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' })} disabled />
                            </div>

                            <div className="row mb-3">
                                <div className="col-md-6">
                                    <label className="fw-bold text-primary">Start Date:</label>
                                    <input
                                        type="date"
                                        className="form-control"
                                        value={formData._start_date}
                                        onChange={(e) => setFormData({ ...formData, start_date: e.target.value })}
                                    />
                                </div>
                                <div className="col-md-6">
                                    <label className="fw-bold text-primary">End Date:</label>
                                    <input
                                        type="date"
                                        className="form-control"
                                        value={formData._end_date}
                                        onChange={(e) => setFormData({ ...formData, end_date: e.target.value })}
                                    />
                                </div>
                            </div>

                            <div className="mb-3">
                                <label className="fw-bold">Company Name:</label>
                                <input type="text" className="form-control" value={formData.company_name} onChange={(e) => setFormData({ ...formData, company_name: e.target.value })} />
                            </div>

                            <div className="mb-3">
                                <label className="fw-bold">Company Address:</label>
                                <textarea className="form-control" rows="2" value={formData.company_address} onChange={(e) => setFormData({ ...formData, company_address: e.target.value })} placeholder="Enter registered office address" />
                            </div>

                            <div className="mb-3">
                                <label className="fw-bold">Domain Name:</label>
                                <input type="text" className="form-control" value={formData.domain_name} onChange={(e) => setFormData({ ...formData, domain_name: e.target.value })} />
                            </div>

                            {/* DYNAMIC PLAN SECTION */}
                            <div className="card p-3 mb-3 bg-light">
                                <div className="d-flex justify-content-between align-items-center mb-2">
                                    <label className="fw-bold text-primary">Selected Plans (SKU) & Counts:</label>
                                    <button className="btn btn-success btn-sm" onClick={handleAddPlan}>+ Add Plan</button>
                                </div>
                                {formData.plans.map((plan, index) => (
                                    <div key={index} className="row g-2 mb-2 align-items-end border-bottom pb-2">
                                        <div className="col-7">
                                            <small className="fw-bold">Plan (SKU)</small>
                                            <select
                                                className="form-control form-control-sm"
                                                value={plan.sku_name}
                                                onChange={(e) => handlePlanChange(index, 'sku_name', e.target.value)}
                                            >
                                                {skuOptions.map((sku, idx) => (<option key={idx} value={sku}>{sku}</option>))}
                                            </select>
                                        </div>
                                        <div className="col-3">
                                            <small className="fw-bold">License Count</small>
                                            <input
                                                type="number"
                                                className="form-control form-control-sm"
                                                value={plan.license_count}
                                                onChange={(e) => handlePlanChange(index, 'license_count', e.target.value)}
                                            />
                                        </div>
                                        <div className="col-3">
                                            <small className="fw-bold">Price (₹)</small>
                                            <input
                                                type="number"
                                                className="form-control form-control-sm"
                                                value={plan.price}
                                                onChange={(e) => handlePlanChange(index, 'price', e.target.value)}
                                                placeholder="Price"
                                            />
                                        </div>
                                        <div className="col-2">
                                            {formData.plans.length > 1 && (
                                                <button className="btn btn-danger btn-sm w-100" onClick={() => handleRemovePlan(index)}>×</button>
                                            )}
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="mb-3">
                                <label className="fw-bold">Agreed Price (₹):</label>
                                <input type="number" className="form-control" value={formData.price} onChange={(e) => setFormData({ ...formData, price: e.target.value })} />
                            </div>

                            <div className="mb-3">
                                <label className="fw-bold text-success">Support Charges (₹):</label>
                                <input
                                    type="number"
                                    className="form-control"
                                    value={formData.support_charges}
                                    onChange={(e) => setFormData({ ...formData, support_charges: e.target.value })}
                                    placeholder="Enter additional support charges"
                                />
                            </div>

                            <div className="mb-3">
                                <label className="fw-bold">Contract Term:</label>
                                <select className="form-control" value={formData.term} onChange={(e) => setFormData({ ...formData, term: e.target.value })}>
                                    <option value="1 Year">1 Year</option>
                                    <option value="2 Years">2 Years</option>
                                    <option value="3 Years">3 Years</option>
                                    <option value="Monthly - Flex">Monthly - Flex</option>
                                </select>
                            </div>

                            <div className="mb-3">
                                <label className="fw-bold">Payment Terms:</label>
                                <select className="form-control" value={formData.payment_term} onChange={(e) => setFormData({ ...formData, payment_term: e.target.value })}>
                                    <option value="Monthly">Monthly</option>
                                    <option value="Quarterly">Quarterly</option>
                                    <option value="Half Yearly">Half Yearly</option>
                                    <option value="Annually">Annually</option>
                                </select>
                            </div>

                            <div className="mb-3">
                                <label className="fw-bold">Authorized Representative Name:</label>
                                <input type="text" className="form-control" value={formData.client_name} onChange={(e) => setFormData({ ...formData, client_name: e.target.value })} />
                            </div>

                            <div className="mb-3">
                                <label className="fw-bold">Representative Designation:</label>
                                <input type="text" className="form-control" value={formData.designation} onChange={(e) => setFormData({ ...formData, designation: e.target.value })} />
                            </div>

                            <div className="mb-3">
                                <label className="fw-bold">Representative Email:</label>
                                <input type="email" className="form-control" value={formData.client_email} onChange={(e) => setFormData({ ...formData, client_email: e.target.value })} />
                            </div>
                        </div>

                        <div className="d-flex justify-content-end" style={{ gap: '10px', borderTop: '1px solid #eee', paddingTop: '15px' }}>
                            <button className="btn btn-secondary btn-sm" onClick={() => setAgreementModal({ open: false, item: null })}>Cancel</button>
                            <button
                                className="btn btn-primary btn-sm"
                                onClick={handleGeneratePDF}
                                disabled={!formData.client_name || !formData.price || !formData.company_name || !formData.company_address || !formData.client_email || formData.plans.length === 0}
                            >
                                Generate & Download PDF
                            </button>
                        </div>
                    </div>
                </div>
            )}

            <Div className="col-md-12 margin_top">
                <table className="table table-bordered table-striped">
                    <thead style={{ backgroundColor: '#f8f9fa' }}>
                        <tr>
                            <th style={{ width: '50px' }}>Sr. No.</th>
                            <th>Domain Name</th>
                            <th>Status (From Comments)</th>
                            <th>Price</th>
                            <th>Add Agreement</th>
                            <th>View Agreement</th>
                        </tr>
                    </thead>
                    <tbody>
                        {currentItems.length > 0 ? currentItems.map((item, index) => (
                            <tr key={item.renewal_id}>
                                <td>{indexOfFirstItem + index + 1}</td>
                                <td style={{ fontWeight: '500' }}>{item.domain_name}</td>
                                <td><Badge bg="secondary" text="dark" className="fw-bold">{item.status_comment}</Badge></td>
                                <td style={{ fontWeight: 'bold' }}>{item.price ? `₹${item.price}` : 'N/A'}</td>
                                <td>
                                    <button
                                        className={`btn ${item.agreement_url ? 'btn-warning' : 'btn-primary'} btn-xs`}
                                        onClick={() => setAgreementModal({ open: true, item: item })}
                                    >
                                        {item.agreement_url ? 'Edit' : 'Create'}
                                    </button>
                                </td>
                                <td><button className="btn btn-info btn-xs text-white" disabled={!item.agreement_url} onClick={() => handleViewAgreement(item.agreement_url)}>View</button></td>
                            </tr>
                        )) : (
                            <tr><td colSpan="6" className="text-center">Loading or no data...</td></tr>
                        )}
                    </tbody>
                </table>
                {statusList.length > itemsPerPage && (
                    <Div className="d-flex justify-content-end mt-3 mb-5">
                        <Stack spacing={2}><Pagination count={totalPages} page={currentPage} onChange={handlePageChange} color="primary" shape="rounded" /></Stack>
                    </Div>
                )}
            </Div>
        </>
    );
}